
// Site yapılandırması
export const siteUrl = 'https://cafeotomasyonu.com';

// İletişim bilgileri
export const contactInfo = {
    phone: '+90 507 588 04 81',
    email: 'info@cafeotomasyonu.com',
    whatsapp: '+90 507 588 04 81',
    facebook: 'cafeotomasyonu',
    instagram: 'cafeotomasyonu',
    linkedin: 'cafeotomasyonu',
    youtube: 'cafeotomasyonu',
    workingHours: 'Pazartesi - Cuma: 09:00 - 18:00',
    address: 'İstanbul, Türkiye'
};